var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"bcx-transition-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isParticipateVisible),expression:"isParticipateVisible"}],ref:"panel",staticClass:"bcx-mobile-fullscreen"},[_c('BCXParticipate')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }